/**
 * @generated SignedSource<<25f804e4a043790af9041280e5c3b207>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RowFund_userArtist$data = {
  readonly artist: {
    readonly " $fragmentSpreads": FragmentRefs<"useArtistCanMessageCompany_artist">;
  } | null;
  readonly " $fragmentType": "RowFund_userArtist";
};
export type RowFund_userArtist$key = {
  readonly " $data"?: RowFund_userArtist$data;
  readonly " $fragmentSpreads": FragmentRefs<"RowFund_userArtist">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RowFund_userArtist",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "ArtistNode",
      "kind": "LinkedField",
      "name": "artist",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useArtistCanMessageCompany_artist"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "UserNode",
  "abstractKey": null
};

(node as any).hash = "e62a8828156504ef9e1784e3fe6aeed3";

export default node;
